<template lang="pug">
  .room.dehumidifier(v-loading="loadingData")
    .divice-block-multi
      single-solid-pie.divice-block-multi-item(:opts="SingleSolidPieOpts1" :series="SingleSolidPieData1" :class="warningFlag1")
      single-solid-pie.divice-block-multi-item(:opts="SingleSolidPieOpts2" :series="SingleSolidPieData2" :class="warningFlag2")
      single-solid-pie.divice-block-multi-item(:opts="SingleSolidPieOpts3" :series="SingleSolidPieData3" :class="warningFlag3")
    .divice-block-line
      single-histogram.divice-block-line-item(:opts="singleHisOpts" :series="airPrepPower" :class="warningFlag4")
      single-histogram.divice-block-line-item(:opts="singleHisOpts1" :series="airPrepPower1" :class="warningFlag5")
      single-histogram.divice-block-line-item(:opts="singleHisOpts2" :series="airPrepPower2" :class="warningFlag6")
      single-histogram.divice-block-line-item(:opts="singleHisOpts3" :series="airPrepPower3" :class="warningFlag7")
    RefreshBlock(@refreshData="refreshData")
</template>
<script>
import nizhouConfigJSON from './config/prepStationBig_data.json'

export default {
  name: 'highPressureFanLess',
  data() {
    return {
      timer: null,
      loadingData: false,
      warningFlag1: '',
      warningFlag2: '',
      warningFlag3: '',
      warningFlag4: '',
      warningFlag5: '',
      warningFlag6: '',
      warningFlag7: '',
      deviceList: [],
      airPrepPower: {},
      airPrepPower1: {},
      airPrepPower2: {},
      airPrepPower3: {},
      singleHisOpts: {
        title: '5#空气制备站总功率',
        histogramName1: 'P',
        max: 70000,
        sign: 'W'
      },
      singleHisOpts1: {
        title: '除湿机1功率',
        histogramName1: 'P',
        max: 15000,
        sign: 'W'
      },
      singleHisOpts2: {
        title: '除湿机2功率',
        histogramName1: 'P',
        max: 15000,
        sign: 'W'
      },
      singleHisOpts3: {
        title: '除湿机3功率',
        histogramName1: 'P',
        max: 15000,
        sign: 'W'
      },
      SingleSolidPieOpts1: { title: '初效过滤压差', max: 200 },
      SingleSolidPieOpts2: { title: '中效过滤压差', max: 200 },
      SingleSolidPieOpts3: { title: '高效过滤压差', max: 200 },
      SingleSolidPieData1: {},
      SingleSolidPieData2: {},
      SingleSolidPieData3: {}
    }
  },
  created() {
    this.setTitles()
  },
  watch: {
    /**
     * 监听路由变化
     * @param {Object} route # 当前路由信息
     */
    $route(route) {
    this.resetData()
      this.setTitles()
      this.loadingData = true
      this.getDatas()
    }
  },
  mounted() {
    this.getDatas()
    // this.getInfo()
    this.timer = setInterval(() => {
      this.getDatas()
    }, this.REFRESH_SECOND)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    resetData() {
      this.warningFlag1 = ''
      this.warningFlag2 = ''
      this.warningFlag3 = ''
      this.warningFlag4 = ''
      this.warningFlag5 = ''
      this.warningFlag6 = ''
      this.warningFlag7 = ''
    },
    getInfo() {
      const routerPath = this.$route.name.split('_')
      this.deviceList = nizhouConfigJSON[routerPath[1]].deviceList
      const stationId = nizhouConfigJSON[routerPath[1]].stationId
      this.$http
        .get(`/bridge/StationInfo?stationId=${stationId}`)
        .then(res => {
          const __data = res.data.deviceList
          const list = __data.map(el => {
            return {
              deviceId: el.deviceId,
              deviceName: el.deviceName
            }
          })
          console.log('list', JSON.stringify(list))
        })
    },
    setTitles() {
      const routerPath = this.$route.name.split('_')
      this.deviceList = nizhouConfigJSON[routerPath[1]].deviceList
      const deviceName =
        nizhouConfigJSON[routerPath[1]][routerPath[2]].deviceName
      this.$set(this.singleHisOpts, 'title', deviceName[0])
    },
    refreshData() {
      this.getDatas()
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.getDatas()
      }, this.REFRESH_SECOND)
    },
    findDeviceId(deviceName) {
      const device = this.deviceList.find(el => {
        return el.deviceName === deviceName
      })
      if (!device) {
        console.log(`deviceName${deviceName}###`)
      }
      return device.deviceId || ''
    },
    findDeviceData(dataList, deviceName) {
      const deviceId = this.findDeviceId(deviceName)
      const device = dataList[deviceId]
      return {
        value: device.value,
        errorLevel: device.errorLevel
      }
    },
    getDatas() {
      console.log('getDatas')
      const routerPath = this.$route.name.split('_')
      this.deviceList = nizhouConfigJSON[routerPath[1]].deviceList
      const deviceDataName = nizhouConfigJSON[routerPath[1]][routerPath[2]].deviceDataName
      const stationId = nizhouConfigJSON[routerPath[1]].stationId
      this.$http
        .get(`/deviceData/Station?stationId=${stationId}`)
        .then(res => {
          this.loadingData = false
          this.$store.commit('setLastRefreshTime')
          const __data = res.data
          const findDeviceData0 = this.findDeviceData(__data, deviceDataName[0])
          const findDeviceData1 = this.findDeviceData(__data, deviceDataName[1])
          const findDeviceData2 = this.findDeviceData(__data, deviceDataName[2])
          const findDeviceData3 = this.findDeviceData(__data, deviceDataName[3])
          const findDeviceData4 = this.findDeviceData(__data, deviceDataName[4])
          const findDeviceData5 = this.findDeviceData(__data, deviceDataName[5])
          const findDeviceData6 = this.findDeviceData(__data, deviceDataName[6])
          this.SingleSolidPieData1 = {
            data1: findDeviceData0.value
          }
          this.warningFlag1 = findDeviceData0.errorLevel
          this.SingleSolidPieData2 = {
            data1: findDeviceData1.value
          }
          this.warningFlag2 = findDeviceData1.errorLevel
          this.SingleSolidPieData3 = {
            data1: findDeviceData2.value
          }
          this.warningFlag3 = findDeviceData2.errorLevel
          this.airPrepPower = {
            data: findDeviceData3.value
          }
          this.warningFlag4 = findDeviceData3.errorLevel
          this.airPrepPower1 = {
            data: findDeviceData4.value
          }
          this.warningFlag5 = findDeviceData4.errorLevel
          this.airPrepPower2 = {
            data: findDeviceData5.value
          }
          this.warningFlag6 = findDeviceData5.errorLevel
          this.airPrepPower3 = {
            data: findDeviceData6.value
          }
          this.warningFlag7 = findDeviceData6.errorLevel
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.dehumidifier {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;
  .divice-block-multi {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    &-item {
      width: calc((100% / 3) - 10px);
      background-color: rgba(255, 255, 255, 0.6);
    }
  }
  .divice-block-line {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    width: 100%;
    height: calc(50% - 15px);
    background-color: transparent;
    &-item {
      width: calc((100% / 4) - 10px);
      background-color: rgba(255, 255, 255, 0.6);
    }
  }
}
</style>
